import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { ReactComponent as ClosePopover } from 'assets/icons/closeIcon.svg'
import s from './ChatPopover.module.scss'

const ChatPopover = ({
	messageTemplate,
	locationPathname,
	setShowPopover,
	setTypingComplete,
	setInputText,
}) => {
	const template = messageTemplate[locationPathname] || messageTemplate.default
	const length =
		(template?.message || '').length ||
		(messageTemplate.default.message || '').length
	const isMobile = useMediaQuery({ query: '(max-width: 768px)' })
	const horizontalClass = length > 28 && isMobile ? s.horizontal : ''

	return (
		<div
			className={s.popover}
			onClick={() => {
				setInputText?.(template.userMessage || '')
				setTypingComplete?.(true)
				setShowPopover(false)
			}}
		>
			<div className={`${s.popover__container} ${horizontalClass}`.trim()}>
				<p className={s.popover__text}>{template.message}</p>

				<button
					type="button"
					className={`${s.close__popover} ${horizontalClass}`.trim()}
					onClick={e => {
						e.stopPropagation()
						setShowPopover(false)
					}}
					aria-label="Close hint"
				>
					<ClosePopover />
				</button>
			</div>
		</div>
	)
}

export default ChatPopover
